<mat-toolbar color="accent">
    <mat-toolbar-row>
      <span>
        Select a Code
      </span>
      <span class="spacer"></span>
      <button mat-raised-button type="button" aria-label="Edit" (click)="handleBack()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button type="button" aria-label="Go Back" mat-raised-button (click)="handleRowAdd()">
        <mat-icon>add</mat-icon>
      </button>
    </mat-toolbar-row>
</mat-toolbar>

<div class="content-header">
  <form>
    <mat-form-field appearance="standard" tabindex="0">
      <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
    </mat-form-field>
  </form>
</div>

<table mat-table matSortDirection="asc" matSortActive="code" [dataSource]="codes" matSort class="mat-elevation-z8">
  
    <ng-container matColumnDef="edit">
      <th mat-header-cell class="mat-header-text" *matHeaderCellDef>Edit</th>
      <td mat-cell class="mat-cell-button" *matCellDef="let element">
        <button mat-mini-fab color="white" aria-label="Example icon button with a menu icon"
          (click)="handleRowEdit( element )">
          <mat-icon>visibility</mat-icon>
        </button>
      </td>
    </ng-container>
   
    <ng-container matColumnDef="code_type">
      <th mat-header-cell class="mat-header-type" *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell class="mat-cell-type" *matCellDef="let element"> 
        {{ element['code_type'] }}
      </td>
    </ng-container>
  
    <ng-container matColumnDef="code">
      <th mat-header-cell class="mat-header-code" *matHeaderCellDef mat-sort-header>Code</th>
      <td mat-cell class="mat-cell-code" *matCellDef="let element"> 
        {{ element['code'] }}
    </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell class="mat-header-description" *matHeaderCellDef mat-sort-header>Description</th>
      <td mat-cell class="mat-cell-description" *matCellDef="let element"> 
        {{ element['description'] }}
      </td>
    </ng-container>

    <ng-container matColumnDef="code_order">
      <th mat-header-cell class="mat-header-order" *matHeaderCellDef mat-sort-header>Order</th>
      <td mat-cell class="mat-cell-order" *matCellDef="let element"> 
        {{ element['code_order'] }}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="is_active">
      <th mat-header-cell class="mat-header-active" *matHeaderCellDef mat-sort-header>Active</th>
      <td mat-cell class="mat-cell-active" *matCellDef="let element"> 
        <span [ngStyle]="{ color: element['is_active'] ? 'green' : 'red' }">
          {{ element['is_active'] ? 'Yes' : 'No' }}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
  </table>

